import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';

import { Tag } from 'legacyComponents/styled/lib';
import { SmallCard as Card } from 'legacyComponents/cards/styles';

import { Tooltip } from 'components';

import { withNamespaces } from 'react-i18next';

export const TopicCard = withNamespaces()(
  ({ cardObject, cardNo, cardColumns }) => {
    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='topic' />;
    }

    const { id, name, taggedCount } = cardObject;

    return (
      <>
        <Tooltip id='topic' delayShow={500} />
        <Link name='channel' params={{ channel: name }}>
          <TopicCardStyled noMargin={noMargin}>
            <Tag id={id} data-for='topic' data-tip={`${taggedCount} items`}>
              #{name}
            </Tag>
          </TopicCardStyled>
        </Link>
      </>
    );
  },
);

const TopicCardStyled = styled(Card)`
  width: 100%;
  display: inline-block;
  border: none;
  &:hover {
    box-shadow: none;
  }
`;

TopicCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
};
